import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const FacebookCircled = forwardRef(({ size = 'medium', fill = 'currentColor', innerFill = 'transparent', ...props }, ref) => {
    const innerFillValue = innerFill === 'transparent' ? 'transparent' : 'var(--cb-icon-inner-color-contrast)';
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { d: "M0 10.01C0 15.517 4.477 20 10 20l.025-6.24H7.672v-2.909h2.353v-1.46c0-2.105 1.548-3.82 3.492-3.82h2.34v2.89h-2.34c-.279 0-.588.372-.588.886v1.486h2.929v2.921H12.94v5.8A9.97 9.97 0 0 0 20 10.01C20 4.475 15.523 0 10 0S0 4.482 0 10.01" }), _jsx("path", { d: "M10.025 13.76 10 20c1.202-.02 1.844-.13 2.941-.446v-5.8h2.917v-2.921h-2.93V9.347c0-.514.31-.885.589-.885h2.34V5.57h-2.34c-1.944 0-3.492 1.715-3.492 3.82v1.46H7.672v2.91z", fill: innerFillValue })] }));
});
FacebookCircled.displayName = 'FacebookCircled';
FacebookCircled.__iconComponentType = 'contrast';
export default FacebookCircled;
//# sourceMappingURL=FacebookCircled.js.map